export default __webpack_public_path__ + "static/media/mtn-logo.e7e235d0.svg";